var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-screen _bg-grey-106 _br-56-24 _pt-56-24 _pb-56-24 _pl-56-16 _pr-56-16",class:{
        'success-screen_dark': _vm.dark,
        'success-screen_is-error': _vm.isError,
        'success-screen_premium': _vm.variant === 'premium',
    }},[_c('div',{staticClass:"success-screen__content"},[_c('h2',{staticClass:"h2 _mb-16-8",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("default",function(){return [_c('p',{staticClass:"p2",domProps:{"innerHTML":_vm._s(_vm.description)}})]}),(_vm.$slots.append)?_c('div',{staticClass:"_mt-24"},[_vm._t("append")],2):_vm._e()],2),_c('div',{staticClass:"success-screen__img"})])
}
var staticRenderFns = []

export { render, staticRenderFns }